import { Box, Typography } from '@mui/material';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { cutUID } from '~/utils/string';

interface DatasetOptionContentProps {
    label?: string;
    fallbackLabel: string;
    modality: string;
    uid: string;
}

export default function DatasetOptionContent({
    label,
    fallbackLabel,
    modality,
    uid,
}: DatasetOptionContentProps) {
    return (
        <Box width="100%" overflow="hidden">
            <SensitiveInfoTypography>
                <Typography
                    component="span"
                    color="white"
                    fontSize={label ? 14 : 13}
                    fontStyle={label ? 'normal' : 'italic'}
                >
                    {label || fallbackLabel}
                </Typography>
            </SensitiveInfoTypography>
            <Box display="flex" gap={0.5}>
                <Typography variant="body2" fontSize={12} color="textSecondary">
                    {modality}
                </Typography>
                <Typography variant="body2" fontSize={12} color="textSecondary">
                    -{' '}
                    <SensitiveInfoTypography>
                        {cutUID(uid, 4, 4)}
                    </SensitiveInfoTypography>
                </Typography>
            </Box>
        </Box>
    );
}
